import { defineStore } from 'pinia'
import { ref, readonly } from 'vue'
import {
  loadBrandingCodeFromStorage,
  loadSkipBrandingCodeCaptureFromStorage,
  saveBrandingCodeToStorage,
  saveSkipBrandingCodeCaptureToStorage,
} from '@/components/stripeCoupon/brandingStorage'
import createLogger from '@/utils/logger'

const logger = createLogger('stores/brandingCode.ts')

export const useBrandingCodeStore = defineStore('brandingCode', () => {
  const brandingCode = ref<string | null>(null)
  const skip = ref<boolean | null>(null)

  const skipBrandingCodeCapture = () => {
    saveSkipBrandingCodeCaptureToStorage(true)
    skip.value = true
  }

  const dontSkipBrandingCodeCapture = () => {
    saveSkipBrandingCodeCaptureToStorage(false)
    skip.value = false
  }

  const isBrandingCodeCaptureSkipped = () => {
    if (skip.value === null) {
      skip.value = loadSkipBrandingCodeCaptureFromStorage()
    }

    return skip.value
  }

  const clearSkipBrandingCodeCaptureConfig = () => {
    saveSkipBrandingCodeCaptureToStorage(null)
    skip.value = null
  }

  const saveBrandingCode = (newBrandingCode: string | null) => {
    logger.log('Saving branding code to storage', brandingCode)
    if (newBrandingCode) {
      brandingCode.value = newBrandingCode
      saveBrandingCodeToStorage(newBrandingCode)
    }
  }

  const getBrandingCode = () => {
    if (!brandingCode.value) {
      brandingCode.value = loadBrandingCodeFromStorage()
    }
    return brandingCode.value
  }

  const removeBrandingCode = () => {
    brandingCode.value = null
    saveBrandingCodeToStorage(null)
  }

  return {
    saveBrandingCode,
    getBrandingCode,
    removeBrandingCode,
    brandingCode: readonly(brandingCode),
    skipBrandingCodeCapture,
    dontSkipBrandingCodeCapture,
    isBrandingCodeCaptureSkipped,
    clearSkipBrandingCodeCaptureConfig,
  }
})
